module.exports = __webpack_public_path__ + "img/zhihi4.a650175c.png";